<template>
  <div class="login-message-banner homeAppCarousal ml12 mr12 mb16">
    <div
      class="login-message-item flex-row color-secondary pd10"
      v-if="getWidgetData.length"
    >
      <!-- Intersection Observer -->
      <Observer :options="{ rootMargin: '0px' }" @intersect.once="itisvisible" />
      <lazy-image
        class="card-img img-product-search"
        alt="default image"
        :src="carouselIcon"
        :src-placeholder="getPlaceHolderImg"
        :intersection-options="{ rootMargin: '600px' }"
      />
      <Carousel :autoplay="4000" :wrap-around="true" :transition="1200">
        <template #addons>
          <div class="login-cars-dots color-secondary">
            {{ carouselTitle }} &nbsp;&nbsp; <Pagination />
          </div>
        </template>
        <Slide v-for="(result, i) in getWidgetData" :key="i">
          <div class="login-text flex-column pl10">
            <div class="location-dynamic-message bold fs-14">
              {{ result }}
            </div>
          </div>
        </Slide>
      </Carousel>

      <button class="actionBtn bold" @click.prevent="handleCtaClick($event)">
        {{ carouselCtaBtn }}
      </button>
    </div>
  </div>
</template>

<script setup>
import LazyImage from "./LazyImage.vue";
</script>

<script>
import Utility from "../helpers/utility";
import { keyMapsAction , keyMapsGetter } from "../helpers/storeKeys";
import { Carousel, Slide, Pagination } from "vue3-carousel";
import setEvents from "../helpers/events";
import Observer from "../assets/Observer.vue";
import { staticImgBaseUrl } from "../config/apiEndpoints";

export default {
  name: "DynamicAppInstall",
  props: ["dataApi", "moduleProps"],
  components: {
    Observer,
    Carousel,
    Slide,
    Pagination,
  },
  data() {
    return {
      modulePropsData: {},
      widgetType: "",
      itemsToShow: 1,
      carouselIcon: "",
      carouselTitle: "",
      carouselCtaBtn: "",
      redirectToAppUrl: "",
      staticImgBaseUrl: staticImgBaseUrl,
    };
  },
  mounted() {
    this.modulePropsData =
      typeof this.moduleProps != null &&
      typeof this.moduleProps != "null" &&
      typeof this.moduleProps != "undefined"
        ? JSON.parse(this.moduleProps)
        : {};

    this.widgetType = this.modulePropsData?.type || "";
    this.redirectToAppUrl = this.modulePropsData?.redirectToAppUrl || "";
  },
  methods: {
    itisvisible() {
      if (this.getWidgetData.length > 0) {
        this.eventFunction(false, {});
      }
    },
    eventFunction(isClicked = false, eObj = {}) {
      let eventType = isClicked ? "Click" : "ngh appInstall impression";
      let userAction = isClicked ? "click" : "ngh appInstall impression";
      let preEventObj = {
        category: this.carouselCtaBtn.toLowerCase(),
        ...eObj,
      };
      const eventObj = Utility.amplitudeEventObj(
        userAction,
        "app install widget",
        "3",
        preEventObj
      );
      setEvents("amplitude", eventType, eventObj);
    },
    handleCtaClick() {
      this.eventFunction(true, {});
      if (this.redirectToAppUrl) {
        window.location.href = this.redirectToAppUrl;
      }
    },
  },
  computed: {
    getWidgetData() {
      const { type } = this.modulePropsData;
      let tempData = this.$store.state.User?.staticWidgetData;
      let data = [];
      let key = type ? type : "";
      if (key) {
        tempData = this.$store.state.User?.staticWidgetData[key] || [];
      }

      if (tempData?.length) {
        this.carouselIcon = tempData[0]?.icon || "";
        this.carouselTitle = tempData[0]?.title || "";
        this.carouselCtaBtn = tempData[0]?.props?.cta || "";
        data = tempData[0]?.subTitle?.split("@") || [];
      }
      return data;
    },
    getPlaceHolderImg(){
      const img =  this.$store.getters[keyMapsGetter.GET_PLACE_HOLDER_IMAGE]?.rect;
      const fallBack = staticImgBaseUrl + '/images/global/default-product-img-lg.png'
      return img || fallBack;
    }
  },
};
</script>
